export default __webpack_public_path__ + "static/media/OptionCountsStore.8ebcbcc9.png";